import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const creditExpirySchema = z.object({
  remain: z.number().int(),
  expiresAt: z.coerce.date(),
});

// Solde de téléchargements : `expiring` liste les crédits utilisables à échéance,
// `expired` compte les téléchargements perdus par expiration.
export const creditBalanceSchema = z.object({
  user: z.string(),
  credit: z.number().int(),
  expiring: z.array(creditExpirySchema).default([]),
  expired: z.number().int().default(0),
});

export type CreditExpiry = z.infer<typeof creditExpirySchema>;

export class CreditBalanceDto extends createZodDto(creditBalanceSchema) {}
